// extracted by mini-css-extract-plugin
export default {"container":"item-gallery_container__q-SOA","photo":"item-gallery_photo__A-Ho0"};